<tec-tile [id]="OPERATION_TYPE.DOCUMENTS"
	[title]="operation.title"
	[formGroup]="group"
	[subtitle]="operation.description"
	[icon]="operation.icon">
	<tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_SECTION_TITLE' | translate"
		[subtitle]="'WORKFLOWS.FORM.OPERATIONS.DOCS_DESCRIPTION' | translate">
		@if (!documentsArray.controls?.length) {
			<tec-empty-state
				[title]="'WORKFLOWS.FORM.OPERATIONS.DOCS_EMPTY' | translate"
				[size]="'default'"
				[labelAction]="'BUTTON.ADD_DOC' | translate"
				[type]="'empty'"
				(clickEvent)="newDoc()"
			></tec-empty-state>
		}
		@for (check of documentsArray.controls; track check; let i = $index) {
			<tec-item [title]="resolveDocRowTitle(documentsArray.controls[i]?.value?.title)"
				[tagImage]="{icon: documentsArray.controls[i]?.value?.icon, status: 'control'}">
				<tec-tag
					[label]="documentsArray.controls[i]?.value?.required ? ('WORKFLOWS.FORM.OPERATIONS.MANDATORY' | translate) : ('WORKFLOWS.FORM.OPERATIONS.OPTIONAL' | translate)"
					[status]="documentsArray.controls[i]?.value?.required ? 'warning' : 'default'"
				></tec-tag>
				<tec-menu
					[options]="workflowsHelper.documentsMenuOpt"
					(valueChange)="documentsMenuChange($event, i)">
					<tec-button-icon
						[icon]="'icon-more'"
						[type]="'default'"
					></tec-button-icon>
				</tec-menu>
			</tec-item>
		}
		@if (documentsArray.controls?.length) {
			<tec-button [label]="'BUTTON.ADD_DOC' | translate" (clickEvent)="newDoc()"></tec-button>
		}
	</tec-tile>

	<!-- CONFIGURACION AVANZADA -->
	<app-workflow-form-advanced-collapse [expanded]="id || expandDocumentsAdvancedForLocaleScroll">
		<div class="item-group">
			<!-- <tec-item [classes]="['item--outline']"
				[title]="'WORKFLOWS.FORM.OPERATIONS.DOCS_TITLE' | translate"
				[tagImage]="{icon: 'icon-text'}">
				<tec-list-detail>
					<span>{{ 'WORKFLOWS.FORM.OPERATIONS.DOCS_TITLE_DESCRIPTION' | translate }}</span>
				</tec-list-detail>
				<tec-input formControlName="title"></tec-input>
			</tec-item>
			<tec-divider></tec-divider> -->
			<tec-item [classes]="['item--outline']"
				[title]="'WORKFLOWS.FORM.OPERATIONS.TUTORIAL' | translate"
				[tagImage]="{icon: 'icon-AI'}">
				<tec-list-detail>
					<span>{{ 'WORKFLOWS.FORM.OPERATIONS.TUTORIAL_DESCRIPTION' | translate }}</span>
				</tec-list-detail>
				<tec-switch formControlName="tutorial" size="sm"></tec-switch>
			</tec-item>
			<tec-divider />
			<tec-item
				[title]="'WORKFLOWS.FORM.OPERATIONS.DOCS_TITLE' | translate"
				[tagImage]="{ icon: 'icon-text', status: 'default' }"
				[clickeable]="false"
				[outline]="true"
			>
				<tec-list-detail>
					<span>{{ 'WORKFLOWS.FORM.OPERATIONS.DOCS_TITLE_DESCRIPTION' | translate }}</span>
				</tec-list-detail>
				<tec-switch formControlName="custom_title" size="sm"></tec-switch>
				@if (hasCustomTitle) {
					<div id="workflow-locale-anchor-documents" class="item-group workflow-locale-anchor">
						<tec-tabs
							[tabs]="workflowLocaleTabs"
							(tabSelected)="onWorkflowLocaleTabSelected($event)"
						/>
						<tec-form-group>
							<tec-input
								[formControl]="getWorkflowLocaleControl('operations', OPERATION_TYPE.DOCUMENTS, 'title', selectedWorkflowLocaleId)"
								[hasError]="reactiveFormService.hasError(getWorkflowLocaleControl('operations', OPERATION_TYPE.DOCUMENTS, 'title', selectedWorkflowLocaleId)) || reactiveFormService.hasError(group.get('title'))"
							/>
						</tec-form-group>
					</div>
				}
			</tec-item>
		</div>
	</app-workflow-form-advanced-collapse>
</tec-tile>
